import { FC } from 'react';
import styled from 'styled-components';

const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
`;
const StyledIcon = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 0.5px solid #d1d1d6;
`;

interface IIconWrapper {
  src: string;
  alt?: string;
}

export const IconWrapper: FC<IIconWrapper> = (props) => {
  const { src, alt = 'Icon' } = props;
  return (
    <StyledIconWrapper>
      <StyledIcon src={src} alt={alt} />
    </StyledIconWrapper>
  );
};
